/**
 * Thin client for connect_four_gm session APIs (Option B).
 */
import { ARCADE, API_PATH_PROXY_ENABLED } from '../../../utils/config';
import { acquireGmLease, endGmSession, noteGmState } from '../gmLease';

/** Lease key for this game's shared GM (game_engines/gm_registry.py). */
export const GM_GAME_ID = 'connect_four';

export const C4_GM_BASE = API_PATH_PROXY_ENABLED
    ? (ARCADE.connect_four?.API_BASE || '')
    : '/c4';

async function parseJson(res) {
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
        const err = new Error(data.error || `Connect Four GM HTTP ${res.status}`);
        err.status = res.status;
        err.data = data;
        throw err;
    }
    return noteGmState(GM_GAME_ID, data);
}

export async function createC4Session() {
    await acquireGmLease(GM_GAME_ID);
    const res = await fetch(`${C4_GM_BASE}/session/create`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: '{}',
    });
    return parseJson(res);
}

export async function moveC4Session(sessionId, { column, player } = {}) {
    const res = await fetch(`${C4_GM_BASE}/session/${sessionId}/move`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ column, player }),
    });
    return parseJson(res);
}

export async function deleteC4Session(sessionId) {
    if (!sessionId) return;
    endGmSession(GM_GAME_ID, sessionId);
    try {
        await fetch(`${C4_GM_BASE}/session/${sessionId}/delete`, { method: 'POST' });
    } catch {
        /* best-effort */
    }
}

export const MOVE_POINTS = 40;
export const ALIGN_2_BONUS = 20;
export const ALIGN_3_BONUS = 60;
export const WIN_BONUS = 400;
export const DRAW_BONUS = 100;
